export const MAP_KEY =
  'pk.eyJ1IjoibHVrYXN6c3VkZXIxOTgwIiwiYSI6ImNrdzB2emdreTA1aW8zMW1venQ3cWF0dmQifQ.DMKrgh2Qgw-69nX5Fuqodw';

export const MAP_CENTER = [-4.593644, 57.04581];
export const MAP_MARKER_COLOR = 'black';
export const MAP_MARKER_SCALE = 0.5;
export const MAP_STYLE = 'mapbox://styles/mapbox/cjaudgl840gn32rnrepcb9b9g';
//export const MAP_STYLE = 'mapbox://styles/mapbox/outdoors-v11';
export const MAP_ZOOM = 7;
export const MAP_FLYTO_ZOOM = 15;
export const MAP_FLYTO_ZOOM_OUT = 15;
export const MAP_FLYOUT_SPEED = 10;
